var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0003 24.6667C36.0003 22.6667 37.6537 22 40.0003 22C41.9452 22 43.8105 22.7726 45.1858 24.1479C46.561 25.5232 47.3337 27.3884 47.3337 29.3333C47.3337 32.3867 45.3203 34.72 43.3337 36.6667L34.0003 46L24.667 36.6667C22.667 34.7333 20.667 32.4 20.667 29.3333C20.667 27.3884 21.4396 25.5232 22.8149 24.1479C24.1901 22.7726 26.0554 22 28.0003 22C30.347 22 32.0003 22.6667 34.0003 24.6667ZM34.0003 24.6667L30.0537 28.6133C29.7828 28.8823 29.5677 29.2022 29.421 29.5546C29.2743 29.907 29.1988 30.2849 29.1988 30.6667C29.1988 31.0484 29.2743 31.4264 29.421 31.7788C29.5677 32.1312 29.7828 32.4511 30.0537 32.72C31.147 33.8133 32.8937 33.8533 34.0537 32.8133L36.8137 30.28C37.5055 29.6523 38.4062 29.3045 39.3403 29.3045C40.2745 29.3045 41.1752 29.6523 41.867 30.28L45.8137 33.8267M42.0003 38L39.3337 35.3333M38.0003 42L35.3337 39.3333",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshakeIcon);
export default __webpack_public_path__ + "static/media/handshake-icon.d2ca7b5f00b120956d554ff4e96f2b38.svg";
export { ForwardRef as ReactComponent };